
import React, {FC} from 'react';
import classNames from 'classnames';
import Button from 'components/Button';
import {NavProps} from 'components/Header';
import {useNav} from 'components/Header/navs';
import ReloadLink from 'components/Header/ReloadLink';
import {Routes} from 'constants/index';

import Group from './Group';

import * as styles from './styles.module.scss';

type BookProps = {
	className?: string
}

export const Book: FC<BookProps> = ({className}) => (
	<div className={classNames(styles.book, className)}>
		<ReloadLink to={Routes.booking}>
			<Button variant='ol-green' >
				Book
			</Button>
		</ReloadLink>
	</div>
);

export const TopNav: FC<NavProps> = ({nav}) => {
	return (
		<div className={styles.nav}>
			{useNav(nav.name).map((g, i) => (
				<Group nav={nav} group={g} key={i} />
			))}
			<Book />
		</div>
	);
};

export default TopNav;
